import React from 'react'
import { Router, Route, Switch } from 'react-router-dom';
// import Loadable from 'react-loadable';
import LoadableComponent from "./LoadableComponent";
import App from './app/pages/app';

// 根据路由按需加载
// const Login = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./app/pages/login').default)
//   }, 'login')
// }
const Login = LoadableComponent(() => import('./app/pages/login'))
console.log(Login)
// const Home = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./app/pages/home').default)
//   }, 'home')
// }
//
// const AlarmRuleView = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./app/pages/alarm/alarmRuleView').default)
//   }, 'alarmRuleView')
// }
const AlarmRuleView = LoadableComponent(() => import('./app/pages/alarm/alarmRuleView'))

// const SendSettingView = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./app/pages/alarm/sendSettingView').default)
//   }, 'sendSettingView')
// }
const SendSettingView = LoadableComponent(() => import('./app/pages/alarm/sendSettingView'))

// const AlarmEventView = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./app/pages/alarm/alarmEventView').default)
//   }, 'alarmEventView')
// }
const AlarmEventView = LoadableComponent(() => import('./app/pages/alarm/alarmEventView'))

// const AlarmLogView = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./app/pages/alarm/alarmLogView').default)
//   }, 'alarmLogView')
// }
const AlarmLogView = LoadableComponent(() => import('./app/pages/alarm/alarmLogView'))

// const TrendReportView = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./app/pages/report/trendReportView').default)
//   }, 'trendReportView')
// }
const TrendReportView = LoadableComponent(() => import('./app/pages/report/trendReportView'))

// const CheckErrorReportView = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./app/pages/report/checkErrorReportView').default)
//   }, 'checkErrorReportView')
// }
const CheckErrorReportView = LoadableComponent(() => import('./app/pages/report/checkErrorReportView'))

// const CheckLogSearchView = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./app/pages/report/checkLogSearchView').default)
//   }, 'checkLogSearchView')
// }
const CheckLogSearchView = LoadableComponent(() => import('./app/pages/report/checkLogSearchView'))

// const CheckStatisticsReportView = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./app/pages/report/checkStatisticsReportView').default)
//   }, 'checkStatisticsReportView')
// }
const CheckStatisticsReportView = LoadableComponent(() => import('./app/pages/report/checkStatisticsReportView'))


// const CompareReportView = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./app/pages/report/compareReportView').default)
//   }, 'compareReportView')
// }
const CompareReportView = LoadableComponent(() => import('./app/pages/report/compareReportView'))

// const StateStatisticsReportView = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./app/pages/report/stateStatisticsReportView').default)
//   }, 'stateStatisticsReportView')
// }
const StateStatisticsReportView = LoadableComponent(() => import('./app/pages/report/stateStatisticsReportView'))

// const TopNReportView = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./app/pages/report/topNReportView').default)
//   }, 'topNReportView')
// }
const TopNReportView = LoadableComponent(() => import('./app/pages/report/topNReportView'))

// const ResourceMonitor = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./windows/resourceMonitor/ResourceMonitor').default)
//   }, 'resourceMonitor')
// }
const ResourceMonitor = LoadableComponent(() => import('./windows/resourceMonitor/ResourceMonitor'))

// const MonitorInfoView = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./windows/resourceMonitor/monitorInfoView').default)
//   }, 'monitorInfoView')
// }
const MonitorInfoView = LoadableComponent(() => import('./windows/resourceMonitor/monitorInfoView'))

// const GroupInfoViewDesView = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./windows/resourceMonitor/groupInfoView_desView').default)
//   }, 'groupInfoViewDesView')
// }
const GroupInfoViewDesView = LoadableComponent(() => import('./windows/resourceMonitor/groupInfoView_desView'))

// const DashboardView = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./app/pages/dashboard').default)
//   }, 'dashboard')
// }
const DashboardView = LoadableComponent(() => import('./app/pages/dashboard'))

// const WeChatView = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./app/pages/weChat/weChatView').default)
//   }, 'weChat')
// }
const WeChatView = LoadableComponent(() => import('./app/pages/weChat/weChatView'))
// 左侧菜单的 立体拓扑、状态巴图、矩阵视图，去掉
// const ThreeDPerspectiveDiagramView = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./windows/resourceMonitor/threeDPerspectiveDiagramView').default)
//   }, 'tuopu')
// }
//
// const ThreeDPerspectiveDiagramView=LoadableComponent(()=>import('./windows/resourceMonitor/threeDPerspectiveDiagramView'))


// const StateStatisticsView = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./windows/resourceMonitor/stateStatisticsView').default)
//   }, 'statebatu')
// }
// const StateStatisticsView=LoadableComponent(()=>import('./windows/resourceMonitor/stateStatisticsView'))


// const TreeMapView = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./windows/resourceMonitor/treeMapView').default)
//   }, 'matrixview')
// }
// const TreeMapView=LoadableComponent(()=>import('./windows/resourceMonitor/treeMapView'))

// const SettingMainView = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./app/pages/setting/settingMainView').default)
//   }, 'setting')
// }
// const SettingMainView=LoadableComponent(()=>import('./app/pages/setting/settingMainView'))

// const UserManageView = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./app/pages/setting/userManageView').default)
//   }, 'userManage')
// }
const UserManageView = LoadableComponent(() => import('./app/pages/setting/userManageView'))

// const RoleManageView = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./app/pages/setting/roleManageView').default)
//   }, 'roleManage')
// }
const RoleManageView = LoadableComponent(() => import('./app/pages/setting/roleManageView'))

// const GroupManageView = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./app/pages/setting/groupManageView').default)
//   }, 'groupManage')
// }
const GroupManageView = LoadableComponent(() => import('./app/pages/setting/groupManageView'))
// const MonitorBatchAddView = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./app/pages/setting/monitorBatchAddView').default)
//   }, 'monitorBatchAdd')
// }
// const MonitorBatchAddView=LoadableComponent(()=>import('./app/pages/setting/monitorBatchAddView'))

// const MonitorBatchDelView = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./app/pages/setting/monitorBatchDelView').default)
//   }, 'monitorBatchDel')
// }
const MonitorBatchDelView = LoadableComponent(() => import('./app/pages/setting/monitorBatchDelView'))

// const MonitorBatchSettingView = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./app/pages/setting/monitorBatchSettingView').default)
//   }, 'monitorBatchSetting')
// }
const MonitorBatchSettingView = LoadableComponent(() => import('./app/pages/setting/monitorBatchSettingView'))

// const ResourceBatchSettingView = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./app/pages/setting/resourceBatchSettingView').default)
//   }, 'resourceBatchSetting')
// }
const ResourceBatchSettingView = LoadableComponent(() => import('./app/pages/setting/resourceBatchSettingView'))

// const TaskPlanView = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./app/pages/setting/taskPlanView').default)
//   }, 'taskPlan')
// }
const TaskPlanView = LoadableComponent(() => import('./app/pages/setting/taskPlanView'))

// const DataSourceConfigureView = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./app/pages/setting/dataSourceConfigureView').default)
//   }, 'dataSourceConfigure')
// }
const DataSourceConfigureView = LoadableComponent(() => import('./app/pages/setting/dataSourceConfigureView'))

// const DatabaseUpdateView = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./app/pages/setting/databaseUpdateView').default)
//   }, 'databaseUpdate')
// }
const DatabaseUpdateView = LoadableComponent(() => import('./app/pages/setting/databaseUpdateView'))

// const DatabaseBackupView = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./app/pages/setting/databaseBackupView').default)
//   }, 'databaseBackup')
// }
const DatabaseBackupView = LoadableComponent(() => import('./app/pages/setting/databaseBackupView'))

// const DatabaseLogManageView = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./app/pages/setting/databaseLogManageView').default)
//   }, 'databaseLogManage')
// }
const DatabaseLogManageView = LoadableComponent(() => import('./app/pages/setting/databaseLogManageView'))

// const SystemRuntimeManageView = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./app/pages/setting/systemRuntimeManageView').default)
//   }, 'systemRuntimeManage')
// }
const SystemRuntimeManageView = LoadableComponent(() => import('./app/pages/setting/systemRuntimeManageView'))

// const SystemDetectionView = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./app/pages/setting/systemDetectionView').default)
//   }, 'systemDetection')
// }
const SystemDetectionView = LoadableComponent(() => import('./app/pages/setting/systemDetectionView'))

// 操作审计
// const OperationalAuditView = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./app/pages/setting/operationalAuditView').default)
//   }, 'operationalAudit')
// }
const OperationalAuditView = LoadableComponent(() => import('./app/pages/setting/operationalAuditView'))

// 软件许可
// const SoftwareLicenseView = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./app/pages/setting/softwareLicenseView').default)
//   }, 'softwareLicense')
// }
const SoftwareLicenseView = LoadableComponent(() => import('./app/pages/setting/softwareLicenseView'))

// 软件许可
// const ResourceImagesView = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./app/pages/setting/resourceImagesView').default)
//   }, 'softwareLicense')
// }
const ResourceImagesView = LoadableComponent(() => import('./app/pages/setting/resourceImagesView'))

//设备信息维护
// const EquipmentInfoMaintenance = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./app/pages/setting/equipmentInfoMaintenanceView').default)
//   }, 'equipmentInfoMaintenance')
// }
const EquipmentInfoMaintenance = LoadableComponent(() => import('./app/pages/setting/equipmentInfoMaintenanceView'))

// const MaintenanceView = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./app/pages/maintenance/maintenanceView').default)
//   }, 'maintenanceView')
// }
const MaintenanceView = LoadableComponent(() => import('./app/pages/maintenance/maintenanceView'))

// <Route path="/home" component={ Home } />
// <Route path="/topo" component={ Topo } />

const Ems = LoadableComponent(() => import('./app/pages/ems'))
const QuickTest = LoadableComponent(() => import('./app/pages/quickTest'))
const BmsSet = LoadableComponent(() => import('./app/pages/bmsSet'))

const AppRoutes = (

  // <Route path="/" component={App}>
  <Switch>
    <Route path="/login" component={Login} />
    <App>
    <Switch>
      {/* <IndexRoute component={ ResourceMonitor } /> */}
      <Route path="/alarm" component={AlarmEventView} />
      <Route path="/alarmRule" component={AlarmRuleView} />
      <Route path="/sendSetting" component={SendSettingView} />
      <Route path="/alarmEvent" component={AlarmEventView} />
      <Route path="/alarmLog" component={AlarmLogView} />
      <Route path="/report" component={TrendReportView} />
      <Route path="/trendReport" component={TrendReportView} />
      <Route path="/checkErrorReport" component={CheckErrorReportView} />
      <Route path="/checkLogSearch" component={CheckLogSearchView} />
      <Route path="/checkStatisticsReport" component={CheckStatisticsReportView} />
      <Route path="/compareReport" component={CompareReportView} />
      <Route path="/stateStatisticsReport" component={StateStatisticsReportView} />
      <Route path="/topNReport" component={TopNReportView} />
      <Route path="/wechat" component={WeChatView} />
      <Route path="/dashboard" component={DashboardView} />
      <Route path="/resourceMonitor" component={ResourceMonitor} />
      <Route path="/monitorInfoView" component={MonitorInfoView} />
      <Route path="/groupInfoViewDesView" component={GroupInfoViewDesView} />
      {/* <Route path="/setting" component={ SettingMainView } /> */}
      <Route path="/setting" component={UserManageView} />
      <Route path="/userManage" component={UserManageView} />
      <Route path="/roleManage" component={RoleManageView} />
      <Route path="/groupManage" component={GroupManageView} />
      {/* <Route path="/monitorBatchAdd" component={ MonitorBatchAddView } /> */}
      <Route path="/monitorBatchDel" component={MonitorBatchDelView} />
      <Route path="/monitorBatchSetting" component={MonitorBatchSettingView} />
      <Route path="/resourceBatchSetting" component={ResourceBatchSettingView} />
      <Route path="/taskPlan" component={TaskPlanView} />
      <Route path="/dataSourceConfigure" component={DataSourceConfigureView} />
      <Route path="/databaseUpdate" component={DatabaseUpdateView} />
      <Route path="/databaseBackup" component={DatabaseBackupView} />
      <Route path="/databaseLogManage" component={DatabaseLogManageView} />
      <Route path="/systemRuntimeManage" component={SystemRuntimeManageView} />
      <Route path="/systemDetection" component={SystemDetectionView} />
      <Route path="/operationalAudit" component={OperationalAuditView} />
      <Route path="/softwareLicense" component={SoftwareLicenseView} />
      <Route path="/resourceImages" component={ResourceImagesView} />
      <Route path="/equipmentInfoMaintenance" component={EquipmentInfoMaintenance} />
      <Route path="/maintenance" component={MaintenanceView} />



      {/* <Route path="/tuopu" component={ ThreeDPerspectiveDiagramView } /> */}
      {/* <Route path="/statebatu" component={ StateStatisticsView } /> */}
      {/* <Route path="/matrixview" component={ TreeMapView } /> */}

      <Route path="/ems" component={Ems} />
      <Route path="/quickTest" component={QuickTest} />
      <Route path="/bmsSet" component={BmsSet} />
      <Route path="/" component={ResourceMonitor} />

      </Switch>
    </App>
  </Switch>
  //  {/* </Route> */}

)

export default AppRoutes;
